<template>
  <div>
    <v-dialog v-model="dialog" max-width="600" transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="initialize" v-bind="attrs" v-on="on" icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title class="title pt-4" :class="color">
            <h4 class="text-truncate">Bankverbindung ändern</h4>
            <v-spacer />
            <v-btn @click="closeDialog" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-row>
            <v-text-field class="mx-8 mt-8" outlined label="IBAN *" :rules="ibanRules" v-model="banking.iban">
            </v-text-field>
          </v-row>
          <v-row>
            <v-text-field class="mx-8" outlined label="Bank *" :rules="requiredRules" v-model="banking.bank">
            </v-text-field>
          </v-row>
          <v-row>
            <v-text-field class="mx-8" outlined label="Kontoinhaber *" :rules="requiredRules" v-model="banking.name">
            </v-text-field>
          </v-row>
          <v-card-actions>
            <v-btn class="ml-4 mb-4" :disabled="!valid" :loading="loading" outlined large color="primary" @click="save">
              <v-icon>mdi-content-save</v-icon>
              Änderungen speichern
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { deepCopy } from "@/lib/utility/deep-copy";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ThgBankingDtoGen } from "@/services/thg/v1/data-contracts";
import { BankingModule } from "@/store/modules/banking.store";
import { Component } from "vue-property-decorator";
import { ibanRule } from "@/lib/rules/ibanRule";
import { requiredRule } from "@/lib/rules/requiredRule";

@Component({
  components: {}
})
export default class CreateOrUpdateBankDialog extends DarkModeHighlightMixin {
  dialog = false;
  loading = false;
  valid = false;

  banking: ThgBankingDtoGen = {
    iban: "",
    bank: "",
    name: ""
  };

  initialize() {
    this.banking = deepCopy(BankingModule.emptyBanking);
  }

  get ibanRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(ibanRule());

    return rules;
  }

  get requiredRules() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  closeDialog() {
    this.dialog = false;
  }

  async save() {
    this.loading = true;
    try {
      await BankingModule.createOrUpdateMyBanking(this.banking);
    } catch (error) {
      this.$toast.error("Bankverbindung konnte nicht geändert werden.");
    } finally {
      this.loading = false;
      this.dialog = false;
    }
  }
}
</script>
